import {useState, useEffect} from "react";
import { feature as topojsonParse } from "topojson-client";
import countriesMapData from '../data/countriesMapData.json';

const useCountriesData = () => {
    const [loadedCountriesData, setLoadedCountriesData] = useState(null);

    useEffect(() => {
      // Parse topojson data directly
      try {
        if (!countriesMapData || !countriesMapData.objects) {
          console.error('Countries map data not loaded or invalid');
          setLoadedCountriesData(null);
          return;
        }

        // Use the first available object in the topojson
        const objectNames = Object.keys(countriesMapData.objects);
        if (objectNames.length === 0) {
          console.error('No objects found in topojson data');
          setLoadedCountriesData(null);
          return;
        }

        const objectName = objectNames[0]; // Use the first available object
        const fc = topojsonParse(countriesMapData, objectName);
        setLoadedCountriesData(fc);
      } catch (error) {
        console.error('Error parsing topojson:', error);
        setLoadedCountriesData(null);
      }
    }, []);
  
    return loadedCountriesData;
};



// const useContriesData = () =>{
//   const loadedCountriesData = topojsonParse(countryTopoJson[0], "map2");
//   // console.log(test);

//   return loadedCountriesData;
// }

export default useCountriesData;